const Tabs = ({ title, active, onClick, className }) => {
  return (
    <button
      key={title}
      className={` text-center py-4 md:px-6 text-lg border-b-2 font-semibold rounded-t-2xl ${
        active ? 'bg-secondary border-secondary-700 text-white' : 'border-gray-300 text-gray-400'
      } ${className}`}
      type="button"
      onClick={onClick}
    >
      <span>{title}</span>
    </button>
  );
};

export default Tabs;
